import { Nullable } from '@/utils/types';
import { PipelineStageEnum } from '@/bundles/Pipelines/types';
import { PipelineStageGroupEnum } from '@/bundles/Pipeline/types';

export const PIPELINE_STAGE_GROUP_ORDER: readonly PipelineStageGroupEnum[] = [
  PipelineStageGroupEnum.Prospect,
  PipelineStageGroupEnum.Active,
  PipelineStageGroupEnum.Loi,
  PipelineStageGroupEnum.UnderContract,
  PipelineStageGroupEnum.ClosedWon,
];

export const pipelineStageGroupLabels: Readonly<Record<PipelineStageGroupEnum, string>> = {
  [PipelineStageGroupEnum.Prospect]: 'Prospect',
  [PipelineStageGroupEnum.Active]: 'Active',
  [PipelineStageGroupEnum.Loi]: 'LOI',
  [PipelineStageGroupEnum.UnderContract]: 'Under Contract',
  [PipelineStageGroupEnum.ClosedWon]: 'Closed Won',
};

export function getPipelineStageGroupLabel (group: PipelineStageGroupEnum): string {
  return pipelineStageGroupLabels[group] ?? group;
}

export const STAGE_TO_GROUP: Readonly<Record<PipelineStageEnum, Nullable<PipelineStageGroupEnum>>> = {
  [PipelineStageEnum.appointment_pending]: PipelineStageGroupEnum.Prospect,
  [PipelineStageEnum.appointment_scheduled]: PipelineStageGroupEnum.Prospect,
  [PipelineStageEnum.presentation_scheduled]: PipelineStageGroupEnum.Prospect,
  [PipelineStageEnum.exclusive_pending]: PipelineStageGroupEnum.Prospect,
  [PipelineStageEnum.exclusive_secured]: PipelineStageGroupEnum.Active,
  [PipelineStageEnum.rfp_loi]: PipelineStageGroupEnum.Loi,
  [PipelineStageEnum.contract_lease_working]: PipelineStageGroupEnum.Loi,
  [PipelineStageEnum.under_contract]: PipelineStageGroupEnum.UnderContract,
  [PipelineStageEnum.closed_won]: PipelineStageGroupEnum.ClosedWon,
  [PipelineStageEnum.closed_construction_pending]: PipelineStageGroupEnum.ClosedWon,
  [PipelineStageEnum.on_hold]: null,
  [PipelineStageEnum.closed_lost]: null,
};

export function stageToGroup (stage: PipelineStageEnum): Nullable<PipelineStageGroupEnum> {
  return STAGE_TO_GROUP[stage] ?? null;
}

const GROUP_TO_STAGES: Record<PipelineStageGroupEnum, PipelineStageEnum[]> = Object.entries(STAGE_TO_GROUP)
  .reduce<Record<string, PipelineStageEnum[]>>((acc, [stage, group]) => {
    if (group === null) return acc;
    if (!acc[group]) acc[group] = [];
    acc[group].push(Number(stage) as PipelineStageEnum);
    return acc;
  }, {}) as Record<PipelineStageGroupEnum, PipelineStageEnum[]>;

export function stagesInGroup (group: PipelineStageGroupEnum): PipelineStageEnum[] {
  return [...(GROUP_TO_STAGES[group] ?? [])];
}

export const PIPELINE_STAGE_ORDER: readonly PipelineStageEnum[] = Object.keys(STAGE_TO_GROUP)
  .map(Number) as PipelineStageEnum[];

export function isStageGroupSelected (stages: PipelineStageEnum[], group: PipelineStageGroupEnum): boolean {
  const showAllStages = stages.length === 0;
  return showAllStages || stagesInGroup(group).some(stage => stages.includes(stage));
}
